<div class="tips-dialog-image">
  <img src="assets/icons/icon_dicas.svg" alt="Dicas" width="80px" />
</div>
<div class="tips-dialog-card">


  <h5 class="tips-dialog-title">{{ tip!.title }}</h5>
  <div style="display: flex; flex-wrap: nowrap;    align-items: center;padding-bottom: 10px;">

    @if(tip!.icon) {
    <div style="width: 80px; padding-right: 20px;">
      <img [src]="tip!.icon" alt="Icon" width="80px" />
    </div>}
    <div *ngIf="tip" class="tips-dialog-content">
      <span class="tips-dialog-message">{{ tip!.message }}</span>
    </div>
  </div>
  <div class="tips-dialog-actions">
    @if(tip!.routerlink) {
    <a mat-button [routerLink]="tip!.routerlink" (click)="close()"> {{ tip!.linkText }}</a>}
    <a mat-button (click)="close()">Voltar</a>
  </div>
</div>